import { render } from "./UniversalLayout.vue?vue&type=template&id=75abfa4c&scoped=true"
import script from "./UniversalLayout.vue?vue&type=script&lang=js"
export * from "./UniversalLayout.vue?vue&type=script&lang=js"

import "./UniversalLayout.vue?vue&type=style&index=0&id=75abfa4c&scoped=true&lang=css"
import "./UniversalLayout.vue?vue&type=style&index=1&id=75abfa4c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75abfa4c"]])

export default __exports__